<template>
    
    <div @click="callSelectIndex" 
    class="myDatesBarCompnentsDiv text-xs lg:text-base">

        <div class="w-24">  

            <label> {{myDate.date}}</label>
        </div>

        <div>

            <label class="w-32"> {{myDate.day}}</label>
        </div>
    </div>
</template>

<script>
export default {

    props:{

        myDate: {
            
            type: Object
        },

        index: 0,

        selectIndex: {

            type: Function
        }
    },
    
    methods:{

        showIndex(){

            // console.log(`index: ${this.index}`)
        },

        callSelectIndex(){

            this.selectIndex(this.myDate, this.index);
        }
    }

}
</script>

<style>

</style>